/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardian_Link_No_ResultInputs */

const fr_guardian_link_no_result = /** @type {(inputs: Guardian_Link_No_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun enfant trouvé.`)
};

/**

* @param {Guardian_Link_No_ResultInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const guardian_link_no_result = /** @type {((inputs?: Guardian_Link_No_ResultInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardian_Link_No_ResultInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_guardian_link_no_result(inputs)
});